const faqStructuredData = {
  init() {
    document.addEventListener('DOMContentLoaded', () => {
      let ldjsonElement = document.querySelector('[type="application/ld+json"]')
      if (!ldjsonElement) {
        ldjsonElement = document.createElement('script')
        ldjsonElement.setAttribute('type', 'application/ld+json')
      }

      const faqItems = this.getFaq()
      const ldJson = this.getFaqLdJsonContent(faqItems)

      if (ldJson) {
        const headElement = document.querySelector('head')
        headElement.appendChild(ldjsonElement)
        ldjsonElement.innerHTML = JSON.stringify(ldJson)
      }
    })
  },
  getFaq() {
    let faqContainer = document.querySelector('.r-accordion')
    if (faqContainer) {
      return this.getFaqItems(faqContainer, '.accordion-item', '.accordion-item__title', '.accordion-item__text')
    }

    faqContainer = document.querySelector('.faq-container')
    if (faqContainer) {
      return this.getFaqItems(faqContainer, '.faq-item', 'faq-title', '.faq-description')
    }

    return null
  },
  getFaqItems(faqContainer, itemClass, titleClass, descriptionClass) {
    const faqItems = []
    const faqRows = faqContainer.querySelectorAll(itemClass)
    if (!faqRows) return faqItems

    faqRows.forEach(row => {
      const question = row.querySelector(titleClass)
      const answer = row.querySelector(descriptionClass)
      faqItems.push({
        question: question.textContent,
        answer: answer.textContent
      })
    })

    return faqItems
  },
  getFaqLdJsonContent(faqItems) {
    if (!faqItems) return ''

    const ldJson = {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: faqItems.map(item => {
        return {
          '@type': 'Question',
          name: item.question,
          acceptedAnswer: {
            '@type': 'Answer',
            text: item.answer
          }
        }
      })
    }
    return ldJson
  }
}

faqStructuredData.init()
